<template>
  <div class="position-ab">
    <div
      :class="
        !editStatus && billStatus != '0'
          ? 'ccui-app-iframe-no-operate-container'
          : 'ccui-app-box-iframe-operate-container'
      "
    >
      <template v-if="labelShow">
        <breadcrumbSourcing
          :breadcrumb-data="breadcrumbData"
        ></breadcrumbSourcing>
      </template>
      <div
        :class="
          !editStatus && billStatus != '0'
            ? 'ccui-app-iframe-container-no-operate-detail'
            : 'ccui-app-iframe-container-detail'
        "
      >
        <div class="ccui-app-iframe-container-detail-body">
          <div class="ccui-tab-iframe">
            <div class="ccui-tab-wrapper">
              <el-button type="table-top-active" size="mini">
                评分表模板
              </el-button>
            </div>
            <el-checkbox
              class="chooseCheck"
              v-model="checked"
              :disabled="billStatus === '1' || joinExpertCount < 5"
              >去掉最低分和最高分（仅限技术评分）</el-checkbox
            >
            <template v-if="editStatus">
              <div class="fr">
                <el-button type="single-number" plain @click="addNew"
                  >新增</el-button
                >
                <el-button type="single-number" plain @click="editData"
                  >编辑</el-button
                >
                <el-button
                  type="single-number"
                  style="z-index:1"
                  plain
                  @click="copyData"
                  >复制</el-button
                >
                <!--              <el-button type="single-number" plain>导出Excel</el-button>-->
                <!--              <el-button type="primary" plain>复制</el-button>-->
              </div>
            </template>
            <template v-else>
              <div class="fr">
                <el-button
                  type="single-number"
                  style="z-index:1"
                  @click="exportPdf"
                  >导出Excel</el-button
                >
              </div>
            </template>
            <div class="clearfix"></div>
          </div>
          <div
            class="el-table el-table--fit el-table--border el-table--scrollable-x el-table--enable-row-hover"
            style="overflow: auto"
          >
            <table
              style="overflow: hidden;width: 100%"
              ref="scoreTable"
              class="dic-sub-table-style01"
            >
              <tr class="el-table__header-wrapper">
                <template v-if="editStatus">
                  <th class="wd6">
                    <div class="cell">选择</div>
                  </th>
                </template>
                <th class="wd2">
                  <div class="cell">序号</div>
                </th>
                <template v-if="subPackageFlag == '1'">
                  <th class="wd20">
                    <div class="cell wd20">包件名称</div>
                  </th>
                </template>
                <th class="wd13">
                  <div class="cell">评审项目</div>
                </th>
                <th class="wd13">
                  <div class="cell">项目权重</div>
                </th>
                <th class="wd20">
                  <div class="cell">评审细则</div>
                </th>
                <th class="wd13">
                  <div class="cell">细则权重</div>
                </th>
                <th class="wd20 lastrightcell">
                  <div class="cell">评审标准</div>
                </th>
              </tr>
              <template v-if="tableData.length > 0">
                <template v-for="(item, index) in tableData">
                  <template v-for="(projectItem, pIndex) in item.sscScoreBOS">
                    <tr
                      class="el-table__body-wrapper is-scrolling-left el-table__row hover-row"
                      v-for="(detailItem,
                      dIndex) in projectItem.sscScoreItemBOS"
                      :key="index + 'e' + pIndex + 'a' + dIndex"
                    >
                      <template v-if="editStatus && dIndex == 0">
                        <td
                          :rowspan="projectItem.sscScoreItemBOS.length"
                          :class="
                            index == tableData.length - 1 &&
                            pIndex == item.sscScoreBOS.length - 1
                              ? 'lastbottomcell'
                              : ''
                          "
                        >
                          <div class="cell wd6">
                            <el-checkbox
                              :key="item.packId + '' + projectItem.scoreItem"
                              v-model="projectItem.radio"
                              @change="
                                changeCheckbox(index, pIndex, dIndex, $event)
                              "
                            ></el-checkbox>
                          </div>
                        </td>
                      </template>
                      <template
                        v-if="!editStatus && pIndex == 0 && dIndex == 0"
                      >
                        <td
                          :rowspan="computeRowSpan(index)"
                          :class="
                            index == tableData.length - 1
                              ? 'lastbottomcell'
                              : ''
                          "
                        >
                          <div class="cell el-tooltip wd6" :title="index + 1">
                            {{ index + 1 }}
                          </div>
                        </td>
                      </template>
                      <template v-if="editStatus && dIndex == 0">
                        <td
                          :rowspan="projectItem.sscScoreItemBOS.length"
                          :class="
                            index == tableData.length - 1 &&
                            pIndex == item.sscScoreBOS.length - 1
                              ? 'lastbottomcell'
                              : ''
                          "
                        >
                          <div
                            class="cell el-tooltip wd6"
                            :title="projectItem.showIndex"
                          >
                            {{ projectItem.showIndex }}
                          </div>
                        </td>
                      </template>
                      <template v-if="subPackageFlag == '1'">
                        <template
                          v-if="!editStatus && pIndex == 0 && dIndex == 0"
                        >
                          <td
                            :rowspan="computeRowSpan(index)"
                            :class="
                              index == tableData.length - 1
                                ? 'lastbottomcell'
                                : ''
                            "
                          >
                            <div
                              class="cell el-tooltip wd20"
                              :title="item.packName"
                            >
                              {{ item.packName
                              }}<span
                                class="red"
                                v-if="
                                  Number(item.packStatus) == 2 ||
                                    Number(item.packStatus) == 5
                                "
                                >（已流标）</span
                              >
                            </div>
                          </td>
                        </template>
                        <template v-if="editStatus && dIndex == 0">
                          <td
                            :rowspan="projectItem.sscScoreItemBOS.length"
                            :class="
                              index == tableData.length - 1 &&
                              pIndex == item.sscScoreBOS.length - 1
                                ? 'lastbottomcell'
                                : ''
                            "
                          >
                            <div
                              class="cell el-tooltip wd20"
                              :title="item.packName"
                            >
                              {{ item.packName }}
                            </div>
                          </td>
                        </template>
                      </template>
                      <template v-if="dIndex == 0">
                        <td
                          :rowspan="projectItem.sscScoreItemBOS.length"
                          :class="
                            index == tableData.length - 1 &&
                            pIndex == item.sscScoreBOS.length - 1
                              ? 'lastbottomcell'
                              : ''
                          "
                        >
                          <div
                            class="cell el-tooltip wd13"
                            :title="projectItem.scoreItemStr"
                          >
                            {{ projectItem.scoreItemStr }}
                          </div>
                        </td>
                      </template>
                      <template v-if="dIndex == 0">
                        <td
                          :rowspan="projectItem.sscScoreItemBOS.length"
                          :class="
                            index == tableData.length - 1 &&
                            pIndex == item.sscScoreBOS.length - 1
                              ? 'lastbottomcell'
                              : ''
                          "
                        >
                          <div
                            class="cell el-tooltip wd13"
                            :title="projectItem.weight"
                          >
                            {{
                              projectItem.weight
                                ? Number(projectItem.weight).toFixed(2)
                                : projectItem.weight
                            }}
                          </div>
                        </td>
                      </template>
                      <td
                        :class="
                          index == tableData.length - 1 &&
                          pIndex == item.sscScoreBOS.length - 1 &&
                          dIndex == projectItem.sscScoreItemBOS.length - 1
                            ? 'lastbottomcell'
                            : ''
                        "
                      >
                        <div
                          class="cell el-tooltip wd20"
                          :title="detailItem.scoreRule"
                        >
                          {{ detailItem.scoreRule }}
                        </div>
                      </td>
                      <td
                        :class="
                          index == tableData.length - 1 &&
                          pIndex == item.sscScoreBOS.length - 1 &&
                          dIndex == projectItem.sscScoreItemBOS.length - 1
                            ? 'lastbottomcell'
                            : ''
                        "
                      >
                        <div
                          class="cell el-tooltip wd6"
                          :title="detailItem.scoreWeight"
                        >
                          {{
                            detailItem.scoreWeight
                              ? Number(detailItem.scoreWeight).toFixed(2)
                              : detailItem.scoreWeight
                          }}
                        </div>
                      </td>
                      <td
                        class="lastrightcell"
                        :class="
                          index == tableData.length - 1 &&
                          pIndex == item.sscScoreBOS.length - 1 &&
                          dIndex == projectItem.sscScoreItemBOS.length - 1
                            ? 'lastbottomcell'
                            : ''
                        "
                      >
                        <div
                          class="cell el-tooltip wd20"
                          :title="detailItem.scoreStandard"
                        >
                          {{ detailItem.scoreStandard }}
                        </div>
                      </td>
                    </tr>
                  </template>
                </template>
              </template>
              <template v-else>
                <div style="position: relative;display: block;height: 60px">
                  <div
                    style="position: absolute;width: 200px;top: 20px;color: #909399;left:calc(50vw - 180px)"
                  >
                    暂无数据
                  </div>
                </div>
              </template>
            </table>
          </div>
        </div>
      </div>
      <template v-if="editStatus">
        <div class="operate">
          <el-button
            type="text"
            icon="icon-ccui-cancel"
            @click="
              getData();
              editStatus = false;
              radio = '';
              editScoreDataStr = {};
            "
            >取消</el-button
          >
          <el-button
            type="text"
            icon="icon-ccui-save"
            v-preventReClick
            @click="save(1)"
            >保存</el-button
          >
          <el-button
            type="text"
            icon="icon-ccui-agree"
            v-preventReClick
            @click="save(2)"
            >生效</el-button
          >
        </div>
      </template>
      <template v-else>
        <template v-if="billStatus === '0'">
          <div class="operate">
            <el-button
              type="text"
              icon="icon-ccui-edit"
              @click="editStatus = true"
              >编辑</el-button
            >
            <el-button
              type="text"
              icon="icon-ccui-agree"
              v-preventReClick
              @click="save(2)"
              >生效</el-button
            >
          </div>
        </template>
      </template>
      <el-dialog
        :title="editScoreScaleDevelopedTitle"
        :visible.sync="dialogTableVisible"
        width="1000px"
        v-if="dialogTableVisible"
      >
        <editScoreScaleDeveloped
          ref="editScoreScaleDeveloped"
          :editScoreDataStr="editScoreDataStr"
          :scoredPack="tableData"
          :scoreItemDisabled="scoreItemDisabled"
          :operateType="operateType"
        ></editScoreScaleDeveloped>
        <div slot="footer">
          <el-button
            size="mini"
            type="default-mini"
            @click="dialogTableVisible = false"
            >取消</el-button
          >
          <el-button
            size="mini"
            type="primary-font-mini"
            v-preventReClick
            @click="confirmEditScoreScale"
            >确定</el-button
          >
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import editScoreScaleDeveloped from "@/app/sourcingFlow/views/scoreScaleDeveloped/editScoreScaleDeveloped.vue";
import breadcrumbSourcing from "@/app/sourcingFlow/components/breadcrumb-sourcing.vue";
import {
  qryScoreListApi,
  dealExpertScoreFormulateApi,
  qryJoinExpertListApi,
  listPurchaseSchemePackageApi,
  qryBidEvaProcessStatusApi
} from "@/app/sourcingFlow/api/expertEvaluation.js";
import { exportJsonToExcel } from "@/basa/utils/Export2Excel";
import bidEvaProcessStatus from "@/app/sourcingFlow/mixins/getBidEvaProcessStatus.js";

export default {
  name: "scoreScaleDeveloped",
  components: {
    editScoreScaleDeveloped,
    breadcrumbSourcing
  },
  inject: ["reload"],
  mixins: [bidEvaProcessStatus],
  data() {
    return {
      breadcrumbData: {
        titname: "评分表制定",
        status: JSON.parse(sessionStorage.getItem("bidEvaProcessStatus"))
          .billStatusName
      },
      labelShow: false,
      labelType:
        JSON.parse(sessionStorage.getItem("bidEvaProcessStatus")).billStatus ===
        "0"
          ? "development"
          : "setComplete", // 0:制定中 1：制定完成
      billStatus: JSON.parse(sessionStorage.getItem("bidEvaProcessStatus"))
        .billStatus,
      editStatus: false, // 是否编辑状态
      tableData: [],
      radio: "",
      dialogTableVisible: false,
      isTrueClick: true,
      editScoreScaleDevelopedTitle: "新增评分项目",
      radioParentIndex: 0, // 单机选择的第几个
      radioIndex: 0, // 单机选择的第几个
      editScoreDataStr: {}, // 新增或编辑的数据
      operateType: "add", // add新增 edit编辑
      scoreItemDisabled: false, // 评审项目是否禁用
      packList: [], // 可评分包件
      checked: false,
      subPackageFlag: "1",
      joinExpertCount: 0 // 专家数，用于判断是否可勾选去掉最高分和最低分
    };
  },
  watch: {
    editStatus: function(newValue, oldValue) {
      if (newValue) {
        this.editStatusIndex();
      }
    }
  },
  mounted() {
    this.getData();
  },
  methods: {
    init() {
      this.getData();
      this.reload();
    },
    getData() {
      qryBidEvaProcessStatusApi({
        schemeId: JSON.parse(sessionStorage.getItem("expertSourceData"))
          .schemeId,
        joinExpertId: JSON.parse(sessionStorage.getItem("expertSourceData"))
          .joinExpertId,
        purStep: this.$router.history.current.query.menuKey
      }).then(res => {
        this.labelShow = false;
        this.billStatus = res.data.data.billStatus;
        this.labelType =
          this.billStatus === "0" ? "development" : "setComplete"; // 0:制定中 1：制定完成
        sessionStorage.setItem(
          "bidEvaProcessStatus",
          JSON.stringify(res.data.data)
        );
        this.$set(
          this.breadcrumbData,
          "status",
          JSON.parse(sessionStorage.getItem("bidEvaProcessStatus"))
            .billStatusName
        );
        this.labelShow = true;
      });
      listPurchaseSchemePackageApi({
        schemeId: JSON.parse(sessionStorage.getItem("expertSourceData"))
          .schemeId,
        pageNo: 1,
        pageSize: 100
      }).then(res => {
        // 是否分包 1分包0不分包
        // subPackageFlag 是否分包 1分包0不分包
        this.subPackageFlag = res.data.data.subPackageFlag;
        // packStatus1正常2、5流标 不显示流标的包件
        this.packList = res.data.data.purchaseSchemePackageList.filter(
          item => item.packStatus != "5" && item.packStatus != "2"
        );
      });
      qryScoreListApi({
        schemeId: JSON.parse(sessionStorage.getItem("expertSourceData"))
          .schemeId
      }).then(res => {
        this.checked = res.data.data.sumForm === "102";
        res.data.data.rows.forEach((aItem, aIndex) => {
          aItem.sscScoreBOS.forEach((bItem, bIndex) => {
            bItem.radio = false;
          });
        });
        this.tableData = res.data.data.rows;
      });
      // 在专家不少于5个的时候才可勾选(即去掉后不可少于3个)
      qryJoinExpertListApi({
        schemeId: JSON.parse(sessionStorage.getItem("expertSourceData"))
          .schemeId
      }).then(res => {
        this.joinExpertCount = res.data.data.rows.length;
      });
    },
    // 计算合并的行
    computeRowSpan(index) {
      let computeRowSpan = 0;
      this.tableData[index].sscScoreBOS.forEach(projectItem => {
        computeRowSpan += projectItem.sscScoreItemBOS.length;
      });
      return computeRowSpan;
    },
    addNew() {
      if (
        this.tableData.length &&
        this.tableData[this.radioParentIndex].sscScoreBOS.length
      ) {
        this.$set(
          this.tableData[this.radioParentIndex].sscScoreBOS[this.radioIndex],
          "radio",
          false
        );
      }
      this.radio = "";
      // 如果是空的
      if (this.tableData.length === 0) {
        this.editScoreScaleDevelopedTitle = "新增评分项目";
        this.operateType = "add";
        this.dialogTableVisible = true;
      } else {
        // 包件数为空的清空(不分包)
        if (this.packList.length === 0) {
          let flag = true;
          this.tableData.forEach(item => {
            if (item.sscScoreBOS.length != 2) {
              flag = false;
            }
          });
          if (flag) {
            this.$message({
              message:
                "所有包件评分表制定完毕，不能进行新增，请选择需要编辑的包件",
              type: "warning",
              duration: 3000,
              showClose: true,
              ccuiCustom: true
            });
            return;
          } else {
            this.editScoreScaleDevelopedTitle = "新增评分项目";
            this.operateType = "add";
            this.dialogTableVisible = true;
          }
        }
        // 已评审包件数等于包件数，并且每个评审包件的项目已经评审完毕就不能继续新增
        let len = this.tableData.length;
        this.tableData.forEach(obj => {
          //评分表已制顶了包件，但这个包件又被流标了
          if (obj.packStatus == 2 || obj.packStatus == 5) {
            len--;
          }
        });
        if (len === this.packList.length) {
          let flag = true;
          this.tableData.forEach(item => {
            if (item.sscScoreBOS.length != 2) {
              flag = false;
            }
          });
          console.log(flag);

          if (flag) {
            this.$message({
              message:
                "所有包件评分表制定完毕，不能进行新增，请选择需要编辑的包件",
              type: "warning",
              duration: 3000,
              showClose: true,
              ccuiCustom: true
            });
            return;
          } else {
            // 如果还有没有评审完毕的项目可以进行评分
            this.editScoreScaleDevelopedTitle = "新增评分项目";
            this.operateType = "add";
            this.dialogTableVisible = true;
          }
        }
        this.editScoreScaleDevelopedTitle = "新增评分项目";
        this.operateType = "add";
        this.dialogTableVisible = true;
      }
    },
    changeCheckbox(index, pIndex, dIndex, e) {
      if (e) {
        this.radioParentIndex = index;
        this.radioIndex = pIndex;
        this.editScoreDataStr = JSON.parse(
          JSON.stringify(this.tableData[index].sscScoreBOS[pIndex])
        );
        this.tableData.forEach((aItem, aIndex) => {
          aItem.sscScoreBOS.forEach((bItem, bIndex) => {
            if (aIndex === index && bIndex === pIndex) {
              this.$set(
                this.tableData[index].sscScoreBOS[pIndex],
                "radio",
                true
              );
            } else {
              this.$set(
                this.tableData[aIndex].sscScoreBOS[bIndex],
                "radio",
                false
              );
            }
          });
        });
        this.$set(this.tableData[index].sscScoreBOS[pIndex], "radio", true);
      } else {
        this.radioParentIndex = "";
        this.radioIndex = "";
        this.$set(this.tableData[index].sscScoreBOS[pIndex], "radio", false);
        this.editScoreDataStr = {};
      }
      let flag = false;
      this.tableData.forEach((aItem, aIndex) => {
        aItem.sscScoreBOS.forEach((bItem, bIndex) => {
          if (bItem.radio) {
            flag = true;
          }
        });
      });
      if (flag) {
        this.radio = "1";
      } else {
        this.radio = "";
      }
    },
    copyData() {
      if (this.radio !== "") {
        if (this.tableData[this.radioParentIndex].sscScoreBOS.length === 2) {
          this.$message({
            message:
              "评审项目已选择完毕，如需调整，请选择需要调整的评审项目进行编辑！",
            type: "warning",
            duration: 3000,
            showClose: true,
            ccuiCustom: true
          });
          return;
        } else {
          let flag = true;
          this.tableData.forEach(item => {
            if (item.sscScoreBOS.length != 2) {
              flag = false;
            }
          });
          // 已评审包件数等于包件数，并且每个评审包件的项目已经评审完毕就不能复制
          if (this.tableData.length === this.packList.length && flag) {
            this.$message({
              message:
                "所有包件评分表制定完毕，不能进行新增，请选择需要编辑的包件",
              type: "warning",
              duration: 3000,
              showClose: true,
              ccuiCustom: true
            });
            return false;
          }
          if (this.tableData[this.radioParentIndex].sscScoreBOS.length === 0) {
            this.scoreItemDisabled = false;
          }
          if (this.tableData[this.radioParentIndex].sscScoreBOS.length === 1) {
            this.scoreItemDisabled = true;
            this.editScoreDataStr = JSON.parse(
              JSON.stringify(
                this.tableData[this.radioParentIndex].sscScoreBOS[
                  this.radioIndex
                ]
              )
            );
            this.editScoreDataStr.packId = this.tableData[
              this.radioParentIndex
            ].packId;
            this.editScoreDataStr.packName = this.tableData[
              this.radioParentIndex
            ].packName;
            if (
              this.tableData[this.radioParentIndex].sscScoreBOS[0].scoreItem ===
              "1"
            ) {
              this.$set(this.editScoreDataStr, "scoreItem", "0");
              this.$set(this.editScoreDataStr, "scoreItemStr", "技术");
            } else {
              this.$set(this.editScoreDataStr, "scoreItem", "1");
              this.$set(this.editScoreDataStr, "scoreItemStr", "商务");
            }
          }
          this.editScoreScaleDevelopedTitle = "复制评分项目";
          this.operateType = "copy";
          this.dialogTableVisible = true;
        }
      } else {
        this.$message({
          message: "请选择需要复制的包件的评审项目！",
          type: "warning",
          duration: 3000,
          showClose: true,
          ccuiCustom: true
        });
      }
    },
    editData() {
      if (this.radio !== "") {
        this.scoreItemDisabled = true;
        this.editScoreScaleDevelopedTitle = "编辑评分项目";
        this.operateType = "edit";
        this.editScoreDataStr = JSON.parse(
          JSON.stringify(
            this.tableData[this.radioParentIndex].sscScoreBOS[this.radioIndex]
          )
        );
        this.editScoreDataStr.packId = this.tableData[
          this.radioParentIndex
        ].packId;
        this.editScoreDataStr.packName = this.tableData[
          this.radioParentIndex
        ].packName;
        this.dialogTableVisible = true;
      } else {
        this.$message({
          message: "请选择要编辑的包件的评审项目！",
          type: "warning",
          duration: 3000,
          showClose: true,
          ccuiCustom: true
        });
      }
    },
    // 确定新增、编辑、复制评分
    confirmEditScoreScale() {
      if (!this.isTrueClick) {
        return;
      }
      this.$refs.editScoreScaleDeveloped.$refs["editScoreDataForm"].validate(
        valid => {
          this.$refs.editScoreScaleDeveloped.$refs[
            "editScoreDataForm2"
          ].validate(valid2 => {
            if (valid && valid2) {
              let flag = true;
              let radioParentIndexnew = 0;
              let radioIndexnew = 0;
              let dataForm = this.$refs.editScoreScaleDeveloped._data
                .editScoreData;
              if (this.radio !== "" && this.operateType != "add") {
                radioParentIndexnew = this.radioParentIndex;
                radioIndexnew = this.radioIndex;
              }
              dataForm.tableData.forEach(item => {
                if (
                  !item.scoreRule ||
                  (!item.scoreWeight && item.scoreWeight !== 0) ||
                  !item.scoreStandard
                ) {
                  flag = false;
                }
              });
              if (!dataForm.tableData.length) {
                return this.$message({
                  message: "评审细则项目不能为空！",
                  type: "error",
                  duration: 3000,
                  showClose: true,
                  ccuiCustom: true
                });
              }
              if (!flag) {
                return this.$message({
                  message: "评审项目内容不能为空！",
                  type: "error",
                  duration: 3000,
                  showClose: true,
                  ccuiCustom: true
                });
              }
              // 新增
              if (this.operateType === "add") {
                if (this.tableData.length === 0) {
                  this.tableData.unshift({
                    packId: dataForm.packId,
                    packName: dataForm.packName,
                    sscScoreBOS: [
                      {
                        radio: false,
                        scoreItem: dataForm.scoreItem,
                        scoreItemStr: dataForm.scoreItemStr,
                        sumForm: dataForm.sumForm,
                        weight: dataForm.weight,
                        sscScoreItemBOS: dataForm.tableData
                      }
                    ]
                  });
                } else {
                  // 是否分包
                  if (this.subPackageFlag == "1") {
                    // 分包
                    // 查看tableData中是否存在此包件
                    let existPacgFlag = false;
                    let existIndex = 0;
                    try {
                      this.tableData.forEach((item, index) => {
                        if (item.packId === dataForm.packId) {
                          existPacgFlag = true;
                          existIndex = index;
                          throw Error();
                        }
                      });
                    } catch (e) {
                      console.log(e);
                    }
                    if (existPacgFlag) {
                      this.tableData[existIndex].sscScoreBOS.unshift({
                        radio: false,
                        scoreItem: dataForm.scoreItem,
                        scoreItemStr: dataForm.scoreItemStr,
                        sumForm: dataForm.sumForm,
                        weight: dataForm.weight,
                        sscScoreItemBOS: dataForm.tableData
                      });
                    } else {
                      this.tableData.unshift({
                        packId: dataForm.packId,
                        packName: dataForm.packName,
                        sscScoreBOS: [
                          {
                            radio: false,
                            scoreItem: dataForm.scoreItem,
                            scoreItemStr: dataForm.scoreItemStr,
                            sumForm: dataForm.sumForm,
                            weight: dataForm.weight,
                            sscScoreItemBOS: dataForm.tableData
                          }
                        ]
                      });
                    }
                  } else {
                    // 不分包
                    this.tableData[0].sscScoreBOS.unshift({
                      radio: false,
                      scoreItem: dataForm.scoreItem,
                      scoreItemStr: dataForm.scoreItemStr,
                      sumForm: dataForm.sumForm,
                      weight: dataForm.weight,
                      sscScoreItemBOS: dataForm.tableData
                    });
                  }
                }
              }
              // 编辑
              if (this.operateType === "edit") {
                this.tableData[radioParentIndexnew].sscScoreBOS[
                  radioIndexnew
                ].sumForm = dataForm.sumForm;
                this.tableData[radioParentIndexnew].sscScoreBOS[
                  radioIndexnew
                ].weight = dataForm.weight;
                this.tableData[radioParentIndexnew].sscScoreBOS[
                  radioIndexnew
                ].sscScoreItemBOS = dataForm.tableData;
              }
              // 复制
              if (this.operateType === "copy") {
                this.tableData[radioParentIndexnew].sscScoreBOS.unshift({
                  radio: false,
                  scoreItem: dataForm.scoreItem,
                  scoreItemStr: dataForm.scoreItemStr,
                  sumForm: dataForm.sumForm,
                  weight: dataForm.weight,
                  sscScoreItemBOS: dataForm.tableData
                });
              }
              console.log(this.tableData);
              this.tableData[radioParentIndexnew].sscScoreBOS[
                radioIndexnew
              ].sscScoreItemBOS.forEach(item => {
                if (
                  !item.scoreRule ||
                  (!item.scoreWeight && item.scoreWeight !== 0) ||
                  !item.scoreStandard
                ) {
                  flag = false;
                }
              });
              if (flag) {
                let weight = 0;
                this.tableData[radioParentIndexnew].sscScoreBOS[
                  radioIndexnew
                ].sscScoreItemBOS.forEach(item => {
                  weight += Number(item.scoreWeight);
                });
                this.tableData[radioParentIndexnew].sscScoreBOS[
                  radioIndexnew
                ].weight = weight;
                if (this.radio) {
                  this.tableData.forEach((aItem, aIndex) => {
                    aItem.sscScoreBOS.forEach((bItem, bIndex) => {
                      if (
                        aIndex === radioParentIndexnew &&
                        bIndex === radioIndexnew
                      ) {
                        this.$set(
                          this.tableData[aIndex].sscScoreBOS[bIndex],
                          "radio",
                          true
                        );
                      } else {
                        this.$set(
                          this.tableData[aIndex].sscScoreBOS[bIndex],
                          "radio",
                          false
                        );
                      }
                    });
                  });
                }
                this.editStatusIndex();
                this.dialogTableVisible = false;
                this.isTrueClick = false; //防重点击
                setTimeout(() => {
                  this.isTrueClick = true;
                }, 2000);
                var compare = function(x, y) {
                  if (x.scoreItem < y.scoreItem) {
                    let a = x.showIndex,
                      b = y.showIndex;
                    x.showIndex = b;
                    y.showIndex = a;
                    return -1;
                  } else if (x.scoreItem > y.scoreItem) {
                    return 1;
                  } else {
                    return 0;
                  }
                };
                this.tableData.forEach(item => {
                  item.sscScoreBOS.sort(compare);
                });
              } else {
                this.$message({
                  message: "评审项目内容不能为空！",
                  type: "error",
                  duration: 3000,
                  showClose: true,
                  ccuiCustom: true
                });
              }
            }
          });
        }
      );
    },
    // 编辑状态下的序号展示
    editStatusIndex() {
      for (let i = 0; i < this.tableData.length; i++) {
        for (let j = 0; j < this.tableData[i].sscScoreBOS.length; j++) {
          if (i === 0 && j === 0) {
            this.tableData[i].sscScoreBOS[j].showIndex = 1;
          } else if (i === 0 && j === 1) {
            this.tableData[i].sscScoreBOS[j].showIndex = 2;
          } else {
            if (j === 0) {
              if (this.tableData[i - 1].sscScoreBOS.length === 1) {
                this.tableData[i].sscScoreBOS[j].showIndex =
                  this.tableData[i - 1].sscScoreBOS[0].showIndex + j + 1;
              }
              if (this.tableData[i - 1].sscScoreBOS.length === 2) {
                this.tableData[i].sscScoreBOS[j].showIndex =
                  this.tableData[i - 1].sscScoreBOS[1].showIndex + j + 1;
              }
            }
            if (j === 1) {
              this.tableData[i].sscScoreBOS[j].showIndex =
                this.tableData[i].sscScoreBOS[j - 1].showIndex + 1;
            }
          }
        }
      }
    },
    save(type) {
      let confirmMessage = type == 2 ? "生效" : "保存";
      this.$confirm(`您确定${confirmMessage}此评分表制定吗？`, "评分表确定", {
        distinguishCancelAndClose: true,
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        customClass: "ccui-message-box-custom"
      })
        .then(() => {
          let flag = true;
          let errorMessage = "";
          if (type == 2) {
            // 生效
            try {
              this.tableData.forEach(item => {
                let weight = 0;
                item.sscScoreBOS.forEach(aItem => {
                  weight += Number(aItem.weight);
                });
                weight = weight.toFixed(2);
                if (weight != 100) {
                  flag = false;
                  // subPackageFlag 是否分包 1分包0不分包
                  if (this.subPackageFlag == "1") {
                    errorMessage =
                      "包件【" +
                      item.packName +
                      "】的”项目权重“或”细则权重“之和不等于100，不允许进行提交生效，请您确认后再操作！";
                  } else {
                    errorMessage =
                      "”项目权重“或”细则权重“之和不等于100，不允许进行提交生效，请您确认后再操作！";
                  }
                  throw Error();
                }
              });
            } catch (e) {
              console.log(e);
            }
          }
          if (flag) {
            let sscScoreBOS = [];
            this.tableData.forEach(item => {
              item.sscScoreBOS.forEach(aItem => {
                let obj = {};
                obj.packId = item.packId;
                obj.packName = item.packName;
                obj.scoreItem = aItem.scoreItem;
                obj.scoreItemStr = aItem.scoreItemStr;
                obj.weight = aItem.weight;
                if (this.checked) {
                  // 去掉最低分和最高分（仅限技术评分）
                  obj.sumForm = "102";
                } else {
                  obj.sumForm = aItem.sumForm;
                }
                obj.sscScoreItemBOS = aItem.sscScoreItemBOS;
                sscScoreBOS.push(obj);
              });
            });
            dealExpertScoreFormulateApi({
              operType: type,
              schemeId: JSON.parse(sessionStorage.getItem("expertSourceData"))
                .schemeId,
              sscScoreBOS: sscScoreBOS,
              operIdentity: "2"
            }).then(res => {
              this.init();
              this.$message({
                message: type === 1 ? "保存成功" : "生效成功！",
                type: "success",
                duration: 3000,
                showClose: true,
                ccuiCustom: true
              });
              this.editStatus = false;
            });
          } else {
            this.$message({
              message: errorMessage,
              type: "error",
              duration: 3000,
              showClose: true,
              ccuiCustom: true
            });
          }
        })
        .catch(() => {});
    },
    // 导出开始
    exportPdf() {
      this.exportData = [];
      if (this.tableData > 5000) {
        this.$message({
          message: "暂不支持5000行以上大批量数据导出",
          type: "warning",

          offset: document.documentElement.clientHeight / 2 - 21
        });
      } else {
        let id = 0;
        console.log(this.tableData);
        this.tableData.forEach((item, index) => {
          item.sscScoreBOS.forEach(aItem => {
            aItem.sscScoreItemBOS.forEach(bItem => {
              this.exportData.push({
                // id: 1 + index,
                id: id++,
                packName: item.packName,
                scoreItemStr: aItem.scoreItemStr,
                weight: aItem.weight,
                scoreRule: bItem.scoreRule,
                scoreWeight: bItem.scoreWeight,
                scoreStandard: bItem.scoreStandard
              });
            });
          });
        });
        if (this.ExcelJS) {
          this.exportDefaultAll();
        } else {
          this.exportCompatibleAll();
        }
      }
    },
    async exportDefaultAll() {
      const wb = new this.ExcelJS.Workbook();
      const ws1 = wb.addWorksheet("评分表制定列表");
      ws1.views = [{ state: "frozen", ySplit: 1 }];

      ws1.addRow(["评分表制定列表"]);
      ws1.addRow([this.content]);

      if (this.subPackageFlag == "1") {
        ws1.addRow([
          "序号",
          "包件名称",
          "评审项目",
          "项目权重",
          "评审细则",
          "细则权重",
          "评审标准"
        ]);
        ws1.columns = [
          { key: "id", width: 5 },
          { key: "packName", width: 25 },
          { key: "scoreItemStr", width: 25 },
          { key: "weight", width: 25 },
          { key: "scoreRule", width: 50 },
          { key: "scoreWeight", width: 25 },
          { key: "scoreStandard", width: 50 }
        ];
      } else {
        ws1.addRow([
          "序号",
          "评审项目",
          "项目权重",
          "评审细则",
          "细则权重",
          "评审标准"
        ]);
        ws1.columns = [
          { key: "id", width: 5 },
          { key: "scoreItemStr", width: 25 },
          { key: "weight", width: 25 },
          { key: "scoreRule", width: 50 },
          { key: "scoreWeight", width: 25 },
          { key: "scoreStandard", width: 50 }
        ];
      }

      let oneSpanList = [];
      let twoSpanList = [];
      let start = 4;
      let twoStart = 4;
      this.tableData.forEach((item, index) => {
        let devspan = 0;
        item.sscScoreBOS.forEach(a => {
          devspan += a.sscScoreItemBOS.length;
        });
        item.sscScoreBOS.forEach((aItem, aIndex) => {
          let twoDevSpan = 0;
          twoDevSpan += aItem.sscScoreItemBOS.length;
          aItem.sscScoreItemBOS.forEach(bItem => {
            if (this.subPackageFlag == "1") {
              ws1.addRow([
                index + 1,
                item.packName,
                aItem.scoreItemStr,
                aItem.weight,
                bItem.scoreRule,
                bItem.scoreWeight,
                bItem.scoreStandard
              ]);
            } else {
              ws1.addRow([
                index + 1,
                aItem.scoreItemStr,
                aItem.weight,
                bItem.scoreRule,
                bItem.scoreWeight,
                bItem.scoreStandard
              ]);
            }
          });
          twoSpanList.push({
            start: twoStart,
            end: twoDevSpan + twoStart - 1
          });
          twoStart = twoDevSpan + twoStart;
        });
        oneSpanList.push({
          start: start,
          end: devspan + start - 1
        });
        start = devspan + start;
      });
      oneSpanList.forEach(item => {
        ws1.mergeCells("A" + item.start + ":A" + item.end);
        if (this.subPackageFlag == "1") {
          ws1.mergeCells("B" + item.start + ":B" + item.end);
        }
      });
      twoSpanList.forEach(item => {
        if (this.subPackageFlag != "1") {
          ws1.mergeCells("B" + item.start + ":B" + item.end);
        }
        ws1.mergeCells("C" + item.start + ":C" + item.end);
        if (this.subPackageFlag == "1") {
          ws1.mergeCells("D" + item.start + ":D" + item.end);
        }
      });
      const buf = await wb.xlsx.writeBuffer();
      this.saveAs(new Blob([buf]), "评分表制定列表.xlsx");
    },
    exportCompatibleAll() {
      let header = [];
      let filterVal = [];
      if (this.subPackageFlag == "1") {
        header = [
          "序号",
          "包件名称",
          "评审项目",
          "项目权重",
          "评审细则",
          "细则权重",
          "评审标准"
        ];
        filterVal = [
          "id",
          "packName",
          "scoreItemStr",
          "weight",
          "scoreRule",
          "scoreWeight",
          "scoreStandard"
        ];
      } else {
        header = [
          "序号",
          "评审项目",
          "项目权重",
          "评审细则",
          "细则权重",
          "评审标准"
        ];
        filterVal = [
          "id",
          "scoreItemStr",
          "weight",
          "scoreRule",
          "scoreWeight",
          "scoreStandard"
        ];
      }

      const excelArr = this.exportData;
      let count = 0;
      const list = [];
      excelArr.forEach((val, index) => {
        val.index = ++count;
        list.push(val);
      });
      const data = this.formatJson(filterVal, list);
      exportJsonToExcel({
        header,
        data,
        filename: "评分表制定列表"
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.chooseCheck {
  //position: absolute;
  //top: 70px;
  //left: 110px;
  margin-left: 30px;
}
.fr {
  float: right;
}

.wd2 {
  width: 50px;
}
.wd10 {
  width: 100px;
}
.wd13 {
  width: 130px;
}
.wd20 {
  width: 200px;
}

.el-radio-group {
  display: contents;
}
.lastrightcell {
  border-right: none;
}
.red {
  color: red;
}
.lastbottomcell {
  border-bottom: none;
}
</style>
<style>
.ccui-top-bar-wrapper {
  display: none;
}
</style>
